import authService from './auth-service';
import axios from 'axios';
import { ApiResponse } from 'common/interfaces';
import { VehicleOffersEventDescriptionsResponse } from '../hooks/react-query/use-vehicle-offers-event-descriptions/use-vehicle-offers-event-descriptions.types';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export async function getAllEventDescriptions(): Promise<ApiResponse<VehicleOffersEventDescriptionsResponse[]>> {
  const token = await authService.acquireTokenAsync();
  return axios({
    method: 'POST',
    url: `${API_ENDPOINT}/api/eventDescription/GetAllWithWebroles`,
    headers: {
      Authorization: `Bearer ${token}`
    },
    data: {}
  });
}
